import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_InitialCaseSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_InitialCaseSummary' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <h3>
                        Case Summary  for Supervision & Consultation Desired outcomes and overarching goals
                    </h3>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Reasons for Referral </span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>Behavior</td>
                        <td className='w-150'>Frequency</td>
                        <td className='w-150'>Intensity</td>
                        <td className='w-150'>Duration</td>
                        <td className='w-150'>Systems</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtBehavior_1" name="txtBehavior_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtIntensity_1" name="txtIntensity_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_1" name="txtDuration_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtSystems_1" name="txtSystems_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtBehavior_2" name="txtBehavior_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtIntensity_2" name="txtIntensity_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_2" name="txtDuration_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtSystems_2" name="txtSystems_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtBehavior_3" name="txtBehavior_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_3" name="txtFrequency_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtIntensity_3" name="txtIntensity_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_3" name="txtDuration_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtSystems_3" name="txtSystems_3" className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtBehavior_4" name="txtBehavior_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_4" name="txtFrequency_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtIntensity_4" name="txtIntensity_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_4" name="txtDuration_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtSystems_4" name="txtSystems_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtBehavior_5" name="txtBehavior_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_5" name="txtFrequency_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtIntensity_5" name="txtIntensity_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_5" name="txtDuration_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtSystems_5" name="txtSystems_5" className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Initial Goals\Desired Outcome
                    </span>
                    <span className='small'>(Participant's goals for treatment)</span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Parent's/ Guardian's goal(s)
                    </span>
                    <textarea id="txtParentGuardianGoal" name="txtParentGuardiangoal" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Referral source's goal(s)
                    </span>
                    <span className='small'>(if applicable)</span>
                    <textarea id="txtReferralSourceGoal" name="txtReferralSourceGoal" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client's goal(s)
                    </span>
                    <textarea id="txtClientGoal" name="txtClientGoal" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other participant's goal(s) Identify participant(s)
                    </span>
                    <textarea id="txtOtherParticipantGoal" name="txtOtherParticipantGoal" className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <h3>OVERARCHING GOALS MST</h3> 
                    <span className='small'>(list goals to reduce externalizing behaviors)</span>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>(1) Referral behavior(s):</span>
                    <textarea id="txtReferralBehavior_1" name="txtReferralBehavior_1" className='add-only'></textarea>
                    <span className='eleHeader'>Goal:</span>
                    <textarea id="txtGoal_1" name="txtGoal_1" className='add-only'></textarea>
                    <span className='eleHeader'>Goal Measure:</span>
                    <textarea id="txtGoalMeasure_1" name="txtGoalMeasure_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(2) Referral behavior(s):</span>
                    <textarea id="txtReferralBehavior_2" name="txtReferralBehavior_2" className='add-only'></textarea>
                    <span className='eleHeader'>Goal:</span>
                    <textarea id="txtGoal_2" name="txtGoal_2" className='add-only'></textarea>
                    <span className='eleHeader'>Goal Measure:</span>
                    <textarea id="txtGoalMeasure_2" name="txtGoalMeasure_2" className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(3) Referral behavior(s):</span>
                    <textarea id="txtReferralBehavior_3" name="txtReferralBehavior_3" className='add-only'></textarea>
                    <span className='eleHeader'>Goal:</span>
                    <textarea id="txtGoal_3" name="txtGoal_3" className='add-only'></textarea>
                    <span className='eleHeader'>Goal Measure:</span>
                    <textarea id="txtGoalMeasure_3" name="txtGoalMeasure_3" className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(4) Referral behavior(s):</span>
                    <textarea id="txtReferralBehavior_4" name="txtReferralBehavior_4" className='add-only'></textarea>
                    <span className='eleHeader'>Goal:</span>
                    <textarea id="txtGoal_4" name="txtGoal_4" className='add-only'></textarea>
                    <span className='eleHeader'>Goal Measure:</span>
                    <textarea id="txtGoalMeasure_4" name="txtGoalMeasure_4" className='add-only'></textarea> 
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(5) Referral behavior(s):</span>
                    <textarea id="txtReferralBehavior_5" name="txtReferralBehavior_5" className='add-only'></textarea>
                    <span className='eleHeader'>Goal:</span>
                    <textarea id="txtGoal_5" name="txtGoal_5" className='add-only'></textarea>
                    <span className='eleHeader'>Goal Measure:</span>
                    <textarea id="txtGoalMeasure_5" name="txtGoalMeasure_5" className='add-only'></textarea> 
                </p>


                <p className='w-750'>
                    By signing below, I/we agree that I/we participated in developing the above goals. I/we agree that this treatment plan will be the major focus of treatment for me/my child/family.
                </p>




            </div>
        </form>

    )
} 